module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('form.billReminderModal.title')) + " " + _vm._s(_vm.billingNumber))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [(!_vm.canCreateWithFee) ? _c('div', {
    staticStyle: {
      "padding": "10px",
      "text-align": "left",
      "border": "1px solid #e84c4c",
      "background": "#f56c6c",
      "color": "#fff",
      "font-size": "16px",
      "margin-bottom": "30px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('warnings.billReminder.unableToCreateWithFee')))]), _c('br'), _vm._v(" "), (_vm.reminderWarning[0] === 'first_reminder') ? _c('span', [_vm._v("- " + _vm._s(_vm.$t('warnings.billReminder.reasons.oneReminderFee')) + " " + _vm._s(("\n            " + (_vm.reminderWarning[1]) + " ")) + " " + _vm._s(_vm.$t('warnings.billReminder.reasons.oneReminderFeeDays'))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.reminderWarning[0] === 'max_reminder') ? _c('span', [_vm._v("- " + _vm._s(_vm.$t('warnings.billReminder.reasons.max2'))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.reminderWarning[0] === 'not_due') ? _c('span', [_vm._v("- " + _vm._s(_vm.$t('warnings.billReminder.reasons.notDue')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.billReminderModal",
      "hasLabel": true
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "disabled": _vm.disableSaveButton,
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ec0ddb5","hasScoped":false}!./src/app/components/billReminderModal/billReminderModal.html
// module id = 2999
// module chunks = 1